import React, { lazy } from 'react';
import IconFoom from '@/assets/images/menu/icon-foom.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const foomRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/foom',
    name: 'OOM',
    icon: <MenuIcon icon={IconFoom} />,
    sort: 97,
    platforms: [
      CapitalPlatform.Android,
    ],
    routes: [
      {
        path: '/exception/foom/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/foom/analytics')),
      },
      {
        path: '/exception/foom/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/foom/issues/list')),
      },
      {
        path: '/exception/foom/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/foom/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
    ],
  },
];

export default foomRoutes;
